module.exports = __webpack_public_path__ + "static/media/02.021.eb13d221.jpg";